import React from "react";
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Box, Typography, Avatar, IconButton, Chip, Button, Stack,
} from "@mui/material";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

import { SECTION_COLORS, REWARD_TYPE_STYLES } from "../../constants";

const ViewRewardDialog = ({ open, reward, onClose, onEditRequest }) => {
    if (!reward) return null;
    const typeStyle = REWARD_TYPE_STYLES[reward.type] || { label: reward.type, bgcolor: "#f5f5f5", color: "#555" };
    const rows = [
        { label: "Type", value: typeStyle.label },
        { label: "Coût (points)", value: reward.cost_points != null ? reward.cost_points.toLocaleString("fr-FR") : "Gratuit" },
        { label: "Validité", value: reward.validity_days ? `${reward.validity_days} jours` : "Illimitée" },
        { label: "Marque", value: reward.brand },
        { label: "Identifiant", value: reward.id },
        { label: "Créée le", value: reward.created_at ? new Date(reward.created_at).toLocaleDateString("fr-FR") : "–" },
    ];

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
            <DialogTitle sx={{ borderBottom: "2px solid #f1f3f5", px: 3, py: 2, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Box display="flex" alignItems="center" gap={1}>
                    <Avatar sx={{ width: 32, height: 32, background: SECTION_COLORS.rewards.gradient }}>
                        <CardGiftcardIcon sx={{ fontSize: 18 }} />
                    </Avatar>
                    <Box>
                        <Typography variant="h6" fontFamily="Montserrat, sans-serif" fontWeight={700} color="#1a1a2e" fontSize={16}>
                            {reward.name}
                        </Typography>
                        <Typography fontSize={11} color="text.secondary">Détail de la récompense</Typography>
                    </Box>
                </Box>
                <IconButton onClick={onClose} size="small"><CloseIcon /></IconButton>
            </DialogTitle>

            <DialogContent sx={{ pt: "24px !important", px: 3, pb: 2 }}>
                <Box display="flex" alignItems="center" gap={1} mb={2.5} px={2} py={1.25}
                    sx={{
                        borderRadius: 2, bgcolor: reward.active ? "#f0fdf4" : "#fef2f2",
                        border: `1px solid ${reward.active ? "#86efac" : "#fca5a5"}`
                    }}>
                    {reward.active
                        ? <CheckCircleIcon sx={{ fontSize: 18, color: "#16a34a" }} />
                        : <CancelIcon sx={{ fontSize: 18, color: "#DC2626" }} />}
                    <Typography fontSize={13} fontWeight={600} color={reward.active ? "#16a34a" : "#DC2626"}>
                        {reward.active ? "Active" : "Inactive"}
                    </Typography>
                    <Chip label={typeStyle.label} size="small"
                        sx={{ ml: "auto", fontWeight: 700, fontSize: 11, bgcolor: typeStyle.bgcolor, color: typeStyle.color }} />
                </Box>

                {reward.description && (
                    <Typography fontSize={13} color="text.secondary" mb={2}
                        sx={{ fontStyle: "italic", borderLeft: `3px solid ${SECTION_COLORS.rewards.main}40`, pl: 1.5 }}>
                        {reward.description}
                    </Typography>
                )}

                <Stack spacing={1}>
                    {rows.map(({ label, value }) => (
                        <Box key={label} display="flex" alignItems="flex-start" justifyContent="space-between"
                            px={2} py={1} sx={{ borderRadius: 2, bgcolor: "#fafbfd", border: "1px solid #e8ecf1" }}>
                            <Typography fontSize={12} color="text.secondary" fontWeight={500} sx={{ minWidth: 140 }}>{label}</Typography>
                            <Typography fontSize={12} fontWeight={600} color="#1a1a2e" sx={{ textAlign: "right", wordBreak: "break-all" }}>{value}</Typography>
                        </Box>
                    ))}
                </Stack>
            </DialogContent>

            <DialogActions sx={{ px: 3, py: 2, borderTop: "1px solid #e0e0e0", gap: 1 }}>
                <Button onClick={onClose} sx={{ color: "text.secondary", textTransform: "none" }}>Fermer</Button>
                <Button variant="contained" onClick={() => { onClose(); onEditRequest(reward); }}
                    startIcon={<EditIcon />}
                    sx={{ background: SECTION_COLORS.rewards.gradient, textTransform: "none", borderRadius: 2, fontWeight: 600, px: 3 }}>
                    Modifier
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ViewRewardDialog;
